<table class="table table-borderless table-responsive w-auto" *ngIf="fields?.length">
  <tbody>
    <tr *ngFor="let field of fields; index as i">
      <td class="ps-1" [attr.data-test-id]="'field_' + i">
        <b>{{ field.hint | translate }}:</b>
      </td>
      <td [ngSwitch]="field.type" class="value-content pe-1" [attr.data-test-id]="'field-description-' + i">
        <ng-container *ngSwitchCase="infoType.organizationList">
          <app-view-profile-organization-links
            [organizationLink]="field.value"
            [fieldNumber]="i"
            [dataTestId]="'field-description-option'"
            [shouldRedirectWhenNoSession]="true"
          ></app-view-profile-organization-links>
        </ng-container>
        <ng-container *ngSwitchCase="infoType.list">
          <div *ngIf="!isCategoryList(field)">
            <span
              *ngFor="let option of field.value; let isLast = last; index as j"
              [attr.data-test-id]="'field-description-option-' + i + '-' + j"
            >
              {{ option | translate }}{{ isLast ? '' : ', ' }}
            </span>
          </div>
          <span *ngIf="isCategoryList(field)" [attr.data-test-id]="'field-description-option-' + field.hint">
            {{ field.value | formatCategories }}
          </span>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <span class="multi-line-text" [innerHtml]="field.value | translate"></span>
        </ng-container>
      </td>
    </tr>
  </tbody>
</table>
